module.exports = __webpack_public_path__ + "img/loop.955ae4b7.svg";